export default {
  title: '',
  loadingText: '',
  subtitle: '',
  content: '',
  error: {
    tooManyRequests: 'Trop de requêtes, veuillez réessayer plus tard.',
  },
  preBooking: {
    plan: {
      subtitle: 'Plan de paiement Floa (4x) <svg data-v-66cad30d="" class="svg-inline--fa fa-circle-info u-color-success" aria-hidden="true" focusable="false" data-prefix="fal" data-icon="circle-info" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path class="" fill="currentColor" d="M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-112c0-8.8-7.2-16-16-16l-40 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l24 0 0 96-32 0zm48-168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"></path></svg>',
      totalAmount: 'Montant total',
      fees: 'Dont {amount} de frais Floa',
      rank: {
        1: '1ère échéance',
        2: '2ème échéance',
        3: '3ème échéance',
        4: '4ème échéance',
      },
      scheduleRank: {
        2: 'à J+30',
        3: 'à J+60',
        4: 'à J+90',
      },
    },
  },
  booking: {
    title: '@:payment.titleIndividual',
    subtitle: 'Paiement en 4 fois avec notre partenaire Floa',
    book: 'Confirmer & Signer',
    confirm: {
      notice: `<p class="notice-title">Le paiement est effectué via Floa</p><p>La première échéance confirme votre réservation.<br>En validant cette étape, la première échéance sera débitée aujourd'hui et votre contrat pourra être signé.</p>`,
      subtitle: `Vous êtes sur le point de confirmer votre réservation.
Votre financement Floa en 4 fois a déjà été accepté.`,
    },
    plan: {
      subtitle: 'Plan de paiement Floa (4x)',
      totalAmount: '',
      fees: '',
      scheduleRank: {
        2: '',
        3: '',
        4: '',
      },
      rank: {
        1: 'Aujourd\'hui',
        2: '{date}',
        3: '{date}',
        4: '{date}',
      },
    },
    after: {
      totalAmount: '<span class="price-title">Montant total</span><span class="u-color-success price-amount">{amount}</span><span class="price-fees">Dont {fees} de frais Floa</span> <span>Paiement en 4 fois</span> <br> <span>Financement accepté.</span>',
    },
  },
};